import React from "react";
import { SOW_INFO_OPTION } from "../../constants/updateVendorConstants";
import UpdateVendorProfile from "../../container/UpdateVendorProfiles/UpdateVendorProfiles";

const UpdateSow = () => (
  <UpdateVendorProfile bodyContent={SOW_INFO_OPTION} />
);

export default UpdateSow;